import Web3 from "web3";
import axios from "axios";
import {
  bscapidetails,
  defaultchainid,
  idFromName,
  idToSymbol,
  multisigwallet,
  netowrkIDHEX,
  USD_TEST_NET,
} from "./Constents";
import { idTorpc } from "./Constents";
window.pro = window.ethereum;

let web3 = new Web3(window.ethereum);

export const MetaMasklogin = async () => {
  if (window.ethereum) {
    const data = await window.ethereum.enable();
    web3 = new Web3(window.ethereum);
    SwitchNetwork("Binance Smart Chain");
    return data[0];
  } else {
    alert("Metamask not installed");
  }
};

export const getUserAddress = async () => {
  try {
    const address = await web3.eth.getAccounts();
    return address[0];
  } catch (error) {
    console.log(error);
  }
};

export const getContract = async (abi, address) => {
  try {
    const Contract = new web3.eth.Contract(abi, address);
    return Contract;
  } catch (error) {
    console.log(error);
  }
};

export const getContract_for_maal = async (abi, address) => {
  try {
    let web3other = new Web3(
      new Web3.providers.HttpProvider(idTorpc[defaultchainid])
    );
    const Contract = new web3other.eth.Contract(abi, address);
    return Contract;
  } catch (error) {
    console.log(error);
  }
};

export const getContract_for_maal_ETH = async (abi, address) => {
  try {
    let web3other = new Web3(
      new Web3.providers.HttpProvider(idTorpc["1"])
    );
    const Contract = new web3other.eth.Contract(abi, address);
    return Contract;
  } catch (error) {
    console.log(error);
  }
};

export const getContract_other = async (abi, address, rpc) => {
  try {
    let web3other = new Web3(new Web3.providers.HttpProvider(rpc));
    const Contract = new web3other.eth.Contract(abi, address);
    return Contract;
  } catch (error) {
    console.log(error);
  }
};

export const towie = async (amount) => {
  try {
    const number = await web3.utils.toWei(amount.toString(), "ether");
    return number;
  } catch (error) {
    console.log(error);
  }
};

export const fromwie = async (amount) => {
  try {
    const number = web3.utils.fromWei(amount, "ether");
    return number;
  } catch (error) {
    console.log(error);
  }
};

export const getWeb = () => {
  return web3;
};

export const GetChainId = async () => {
  try {
    const id = await web3.eth.getChainId();
    return id;
  } catch (error) {}
};

export const SwitchNetwork = async (network) => {
  try {
    if (window.ethereum) {
      const data = await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: netowrkIDHEX[`${network}`] }], // chainId must be in hexadecimal numbers 38
      });
      console.log("Data", data);
      return data;
    }
  } catch (error) {
    if (error.code === 4902) {
      // If the chain is not added, add it
      console.log("Chain not found, adding chain...");
      await addChainToMetaMask(network);
    } else {
      console.error("Failed to switch or add chain:", error);
    }
  }
};

export const SendNativeCurrnecy = async (amount, address) => {
  try {
    // Check if MetaMask is installed
    if (!window.ethereum) {
      throw new Error("MetaMask is not installed");
    }

    // Connect to MetaMask
    const web3 = new Web3(window.ethereum);

    // Request accounts from MetaMask
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const userAddress = accounts[0]; // Get the connected user's address

    // Convert ETH amount to Wei
    const valueInWei = web3.utils.toWei(amount.toString(), "ether"); // Ensure 'amount' is in string or number

    // Define the transaction
    const transaction = {
      from: userAddress, // Sender's address
      to: address, // Recipient's address
      value: valueInWei, // Amount in Wei
    };

    // Send the transaction
    const txHash = await web3.eth.sendTransaction(transaction);

    return txHash; // Return the transaction hash
  } catch (error) {
    console.error("Error sending transaction:", error);
    throw error;
  }
};

const addChainToMetaMask = async (network) => {
  try {
    const chainDetails = {
      chainId: netowrkIDHEX[network], // Required, must be in hex format
      chainName: network, // Name of the chain
      nativeCurrency: {
        name: idToSymbol[`${idFromName[network]}`], // Name of the native currency
        symbol: idToSymbol[`${idFromName[network]}`], // Symbol for the native currency (e.g., ETH, BNB)
        decimals: 18, // Decimals for the currency
      },
      rpcUrls: [idTorpc[`${idFromName[network]}`]], // RPC URLs
      blockExplorerUrls: [idToSymbol[`${idFromName[network]}`]], // Block Explorer URLs
    };

    // Request MetaMask to add the new chain
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [chainDetails],
    });
    console.log("Chain added successfully!");
  } catch (error) {
    console.error("Failed to add chain:", error);
  }
};

export const formatNumer = (num) => {
  try {
    if (!isFinite(num)) {
      return 0;
    } else if (Number(num) === 0) {
      return Number(num);
    } else if (isNaN(num)) {
      return 0;
    } else {
      return Number(num).toFixed(3);
    }
  } catch (error) {
    return 0;
  }
};

export const isInfiniti = (num) => {
  try {
    if (Number.isFinite(num)) {
      return num;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};

export const FetchContracttx = async () => {
  try {
    const response = await axios.get(bscapidetails.BSC_API_URL).then((res)=>{
      return res.data
    })
    return response
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};
